import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '../../types/HttpHeaders';
import { SKIP_REQUEST_MUTATORS } from '../skip-request-mutators/skip-request-mutators.interceptor';

@Injectable()
export class ContentTypeInterceptor implements HttpInterceptor {
  private static readonly EXCLUDED_STATIC_URLS = ['/background-image', '/plan', '/images'];

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_REQUEST_MUTATORS)) return next.handle(req);

    if (ContentTypeInterceptor.EXCLUDED_STATIC_URLS.some((url) => req.url.endsWith(url))) {
      return next.handle(req);
    }

    const clonedRequest = req.clone({
      headers: req.headers.set(HttpHeaders.CONTENT_TYPE, 'application/json'),
    });

    return next.handle(clonedRequest);
  }
}
